<template>
  <form novalidate @submit.prevent="controller.submit()" ref="root">
    <slot/>
  </form>
</template>

<script setup lang="ts">
  import { nextTick, provide, reactive, watchEffect } from 'vue';
  import { elementRef } from '../../utils/component';
  import { FormController, setFormController, SubmitHook } from '../../utils/form/form';

  const props = defineProps<{
    onSubmit?: SubmitHook;
    disabled?: boolean;
  }>();

  const root = elementRef();

  const controller = reactive(new FormController(props.onSubmit, revealValidationFailure)) as FormController;

  setFormController(controller);

  watchEffect(() => controller.disabled = props.disabled);

  async function revealValidationFailure() {
    await nextTick();
    const errorElement = root.value?.querySelector('.c-validation-failed');
    const modalBody = root.value?.querySelector('.c-modal-body');

    if (modalBody && errorElement && modalBody.contains(errorElement)) {
      const modalBodyRectangle = modalBody.getBoundingClientRect();
      const errorElementRectangle = errorElement.getBoundingClientRect();

      modalBody.scrollTop = errorElementRectangle.top - modalBodyRectangle.top - 50;
    } else
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth' });
      }
  }

  provide('hasForm', true);
</script>